import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {useAxiosInterceptor} from 'hooks';
import {Routers} from 'pages';

interface IAppProps {}

const App: React.FC<IAppProps> = () => {
  const {hydrated} = useAxiosInterceptor();

  return !hydrated ? null : (
    <BrowserRouter>
      <Routers />
    </BrowserRouter>
  );
};

export default App;
